import { SUPPORTED_COUNTRIES } from '@/common/constants/countries'
import { LANGUAGES } from '@/common/constants/languages'
import { z } from '@/lib/zod'

export function EditAccountSchema() {
  return z.object({
    accountKey: z.string().min(1).max(50),
    title: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    country: z.enum([...SUPPORTED_COUNTRIES]),
    locale: z.enum([...LANGUAGES]),
  })
}

export type EditAccountForm = z.infer<ReturnType<typeof EditAccountSchema>>
